import { simpleClient } from 'services/apiGatewayClient';
import { createService } from 'services/genericAPIGatewayService';
import { State } from 'store';
import { Brand } from '../entities/brand';
import { Service } from './services';

export const client = simpleClient<Brand>();
const endpointCreator = () => '/brands';

export const { Actions, Selectors, Sagas } = createService<Brand, Service.Brands>({
  service: Service.Brands,
  client,
  endpointCreator,
  stateConverter: (state: State) => state.clients.brands,
  sagas: ['GET', 'GET_COLLECTION', 'CREATE', 'UPDATE'],
  persistUpdates: true,
});
